import React from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
import PlusIcon from '../../../assets/icons/JSX/PlusIcon'
//
//
const Button: React.FC<{
  text?: string
  onClick?: () => void
  disabled?: boolean
  type?: 'submit' | 'button' | 'reset'
  buttonType?: 'primary' | 'transparent'
  fullWidth?: boolean
  hidePlusIcon?: boolean
  style?: React.CSSProperties
}> = ({
  text,
  onClick,
  disabled = false,
  type,
  buttonType = 'primary',
  fullWidth = false,
  hidePlusIcon = true,
  style,
}) => {
  //
  //
  return (
    <ButtonStyle
      style={style}
      $buttonType={buttonType}
      $fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      type={type ?? 'button'}
    >
      {hidePlusIcon ? null : (
        <div>
          <PlusIcon />
        </div>
      )}
      <span>{text}</span>
    </ButtonStyle>
  )
}
//
const ButtonStyle = styled.button<{ $buttonType: 'primary' | 'transparent'; $fullWidth: boolean }>`
  border: ${({ $buttonType }) =>
    $buttonType === 'primary' ? '1px solid transparent' : `1px solid ${Colors.primaryBlack}`};
  outline: none;
  user-select: none;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14.5px 60px;
  border-radius: 4px;
  width: ${({ $fullWidth }) => ($fullWidth === true ? '100%' : 'fit-content')};
  background-color: ${({ $buttonType }) => ($buttonType === 'primary' ? Colors.primaryRed : Colors.white)};
  height: fit-content;
  /* icon div */
  div {
    margin-right: 10px;
    position: relative;
    height: 10px;
    width: 10px;
    /* icon svg */
    svg {
      position: absolute;
      top: 2px;
      left: 0;
      height: 10px;
      width: 10px;
      color: ${({ $buttonType }) => ($buttonType === 'primary' ? Colors.white : Colors.primaryBlack)};
    }
  }

  /* text span */
  span {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    color: ${({ $buttonType }) => ($buttonType === 'primary' ? Colors.white : Colors.primaryBlack)};
    margin-right: ${({ $buttonType }) => ($buttonType === 'primary' ? '6px' : '0px')};
    margin-left: ${({ $buttonType }) => ($buttonType === 'primary' ? '6px' : '0px')};
  }

  /*  */
  &:hover {
    background-color: ${({ $buttonType }) => ($buttonType === 'primary' ? Colors.hoverRed : Colors.primaryBlack)};

    border-color: ${({ $buttonType }) => ($buttonType === 'primary' ? 'transparent' : Colors.primaryBlack)};

    span {
      color: ${Colors.white};
    }

    div {
      svg {
        color: ${Colors.white};
      }
    }
  }
  /*  */
  &:active {
    opacity: 0.8;
  }
  /*  */
  &:disabled {
    opacity: 0.8;
  }
  /*  */

  /* mobile */
  ${Responsive.mobile} {
    padding: 14.5px 60px;

    span {
      font-size: 14px;
    }
  }
`
//
export default Button
